module.exports = __webpack_public_path__ + "img/OM-green-certificate.d592fdff.png";